import { JointHook } from './joint.hook';

export class EmploymentStatusHook extends JointHook {

  static paths = [
    'EmploymentInformation.employmentStatus',
    'JointAccountInformation.employmentStatus'
  ];

  static execute(path, value, actions) {
    const basePath = path.match(/^EmploymentInformation/) ? 'EmploymentInformation' : 'JointAccountInformation';

    // List of values that would cause the form to show
    const validStatuses = [
      'Employed',
      'Self employed',
      'Student/Employed',
      'Volunteer worker'
    ];

    if (validStatuses.indexOf(value) === -1) {
      actions.deleteData(`${basePath}.employed`);
    }
  }
}
